import { Box, Button, Typography } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';

const ChatFailed = ({ onRefetchInfo }: { onRefetchInfo?: () => any }) => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            <i
                className="fa-light fa-circle-exclamation"
                style={{ fontSize: '50px' }}></i>

            <Typography variant="h2" fontSize={22} sx={{ mt: 2, mb: 4 }}>
                خطا در برقراری ارتباط
            </Typography>

            {onRefetchInfo && (
                <Button
                    variant="contained"
                    startIcon={<ReplayIcon />}
                    onClick={() => onRefetchInfo()}>
                    تلاش دوباره
                </Button>
            )}
        </Box>
    );
};

export default ChatFailed;
